import type { ISerialize } from '@/objects/ISerialize';

export class DisableTimeRequest implements ISerialize {
    public TUID: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { TUID?: string | null }) {
        this.TUID = values.TUID ?? '';
    }

    public serialize(): string {
        return '{' + `"TUID": ${JSON.stringify(this.TUID)}` + '}';
    }

    /**
     * Creates an instance of DisableTimeRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { TUID?: string | null }): DisableTimeRequest {
        return new DisableTimeRequest(values);
    }

    public static _FromServerJson(json: any): DisableTimeRequest {
        return new DisableTimeRequest({ TUID: json.TUID ?? '' });
    }

    /**
     * Creates an instance of DisableTimeRequest from another instance of DisableTimeRequest.
     * @param other The DisableTimeRequest you want to clone
     * @returns A cloned DisableTimeRequest
     */
    public static FromOther(other: DisableTimeRequest): DisableTimeRequest {
        return DisableTimeRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DisableTimeRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'DisableTimeRequest';
}
